'use strict';
/**
 * A side slider list of activities
 */

angular.module('msLegacyActivities').directive('msActivityCards', ['$window', '$timeout', '$interval', '$log', function ($window, $timeout, $interval, $log) {
  // Global variable used to stop animation loops.
  var stopPanning = true;
  // Global variable used to stop animation loops.
  var stopSpeeding = true;
  // Duration of jump scroll
  var t = 1000;
  // Distance to jump scroll. This is changed to the width of the cards once they load.
  var d = 75;
  // Velocity of jump scroll
  var v = d / t;
  // Just creating some global variables used later
  var startTime, panFrame, speedUpFrame, scrollTween, accelerateScrollTween, hoverTimer;
  // Defining these here, actually giving them values after $digest (look for $timeout)
  var cardsRow, cardWidth, prevArrow, nextArrow;
  var checkInterval;

  return {
    restrict: 'EA',
    templateUrl: 'legacyActivities/templates/activity-cards.html',
    scope: {
      'activities': '=msActivityCards',
      'index': '@'
    },
    link: _linkFn
  };

  // Binds up events on the element and the window
  function _bindMouseEvents(scope, element) {
    // Only create these checks when the mouse enters the row.
    // This prevents the scenario where multiple instances of this directive are constantly
    // running their checks at the same time, all the time.
    element.bind('mouseenter', function () {
      checkInterval = $interval(function () {
        _showHideButtons();
      }, 300);
    });
    element.bind('mouseleave', function () {
      _destroyCheckInterval();
      // Wrap this in a $timeout to catch momentum-powered scrolling that continues after the `mouseleave` event.
      // Same delay as Safari's scrollbar hide.
      $timeout(function () {
        _showHideButtons();
      }, 1000);
    });
    // Hide the buttons when the window isn't in focus.
    angular.element($window).on('blur', function () {
      if (prevArrow && nextArrow) {
        prevArrow.addClass('hidden');
        nextArrow.addClass('hidden');
      }
    });
    angular.element($window).on('focus', function () {
      _showHideButtons();
    });

    // If the checkInterval still exists when leaving a page, ensure that it doesn't.
    scope.$on('$destroy', function () {
      _destroyCheckInterval();
    });
  }

  // If there is a checkInterval $interval, destroy it.
  function _destroyCheckInterval() {
    if (angular.isDefined(checkInterval)) {
      // Check the buttons one last time.
      _showHideButtons();
      $interval.cancel(checkInterval);
      checkInterval = undefined;
      // TODO: Better solution than setting to 'undefined':
      // http://stackoverflow.com/questions/23147757/how-to-get-the-status-of-angular-interval-check-if-the-interval-has-been-canc
    }
  }

  // Checks scroll position, and hides the left/right button if the user can't scroll any further in that direction.
  function _showHideButtons() {
    if (cardsRow.clientWidth + cardsRow.scrollLeft >= cardsRow.scrollWidth - 1) {
      prevArrow.removeClass('hidden');
      nextArrow.addClass('hidden');
    } else if (cardsRow.scrollLeft <= 1) {
      nextArrow.removeClass('hidden');
      prevArrow.addClass('hidden');
    } else {
      prevArrow.removeClass('hidden');
      nextArrow.removeClass('hidden');
    }
  }
  //init scope vars from element
  function _init(element) {
    // 'element[0].querySelector' is required so we have access to the scroll properties
    cardsRow = element[0].querySelector('.cards-row');
    cardWidth = cardsRow.querySelector('.card') ? cardsRow.querySelector('.card').getBoundingClientRect().width : 0;
    // For the buttons, we just need to toggle a class, so we will use Angular's element selector.
    prevArrow = element.children('.prevArrow');
    nextArrow = element.children('.nextArrow');

    // Check scroll position after it all renders.
    // Some browsers retain scroll positions across page refreshes (even with Angular messing with the DOM!).
    _showHideButtons();

    // Default scroll distance used when accelerating into a scroll.
    d = cardWidth / 2;

    // Lazy load images by row
    _lazyLoadRowImages(element);
  }

  function _lazyLoadRowImages(element) {
    // Uses scroll monitor to lazy load images when user scrolls row into view
    var rowWatcher = scrollMonitor.create(element);

    rowWatcher.enterViewport(function () {
      angular.element(element).find(document.querySelectorAll('.cards-row li.card')).each(function (index, item) {
        var imagePreview = angular.element(item).find(document.querySelectorAll('.image-preview'));
        var imageSrc = imagePreview.attr('data-image-src');
        var image = new Image();

        image.onload = function () {
          imagePreview.after(image);

          $timeout(function () {
            image.classList.add('show');
          }, index * 100);
        };
        image.onerror = function () {
          $log.error('image failed to load: ', imageSrc);
        };

        image.alt = imagePreview.attr('data-image-alt');
        image.src = imageSrc;
      });

      rowWatcher.destroy();
    });
  }

  function _linkFn(scope, element) {
    _bindMouseEvents(scope, element);
    // Wait until the end of $digest to get these elements. (They might not exist yet.)
    $timeout(function () {
      return _init(element);
    });
    // Scrolls row by 2 card widths. Also chooses an laternate easing function if the content is already moving.
    scope.jumpScroll = _jumpScroll;
    // Accelerates content into a constant scroll.
    scope.panScroll = function (direction) {
      _panScroll(element, direction);
    };
    // Stops any panning or tweening animations.
    scope.stopPanning = function (direction) {
      _stopPanning(element, direction);
    };
  }

  // Scrolls row by 2 card widths. Also chooses an laternate easing function if the content is already moving.
  function _jumpScroll(direction) {
    stopSpeeding = false;
    direction = _interpretDirection(direction);
    // If the content is not already moving, TWEEN.Easing can handle it.
    if (stopPanning) {
      scrollTween = new TWEEN.Tween(cardsRow).to({
        scrollLeft: cardsRow.scrollLeft + cardWidth * 2 * direction
      }, 1000).easing(TWEEN.Easing.Exponential.In);
      scrollTween.start();
      _scrollTweenRepeater();
    }
    // If the content is already moving, apply special easing functions.
    else {
        startTime = window.performance.now();
        _speedUp(direction);
      }
  }

  // Accelerates content into a constant scroll.
  function _panScroll(element, direction) {

    direction = _interpretDirection(direction);

    // Update cardsRow
    cardsRow = element[0].querySelector('.cards-row');

    // Ensure panning is allowed.
    stopPanning = false;

    // Accelerate into the pan
    hoverTimer = $timeout(function () {
      $timeout.cancel(hoverTimer);

      accelerateScrollTween = new TWEEN.Tween(cardsRow).to({
        scrollLeft: cardsRow.scrollLeft + d * direction
      }, t).easing(TWEEN.Easing.Cubic.In).onComplete(function () {
        // Once acceleration is complete, pan with constant velocity
        // I got better results by not passing an anonymous function to requestAnimationFrame,
        // so I set the direction before entering the animation loop.
        if (direction === 1) {
          panFrame = requestAnimationFrame(_panLeftRepeater);
        } else {
          panFrame = requestAnimationFrame(_panRightRepeater);
        }
        stopPanning = cardsRow.scrollLeft === cardsRow.scrollLeftMax;
      });
      accelerateScrollTween.start();
      _scrollTweenRepeater();
    }, 600);
  }

  // Stops any panning or tweening animations.
  function _stopPanning(element, direction) {

    var hoverIntent = !$timeout.cancel(hoverTimer);
    if (hoverIntent) {

      direction = _interpretDirection(direction);

      // Stop any existing scrolling
      accelerateScrollTween.stop();
      if (scrollTween) {
        scrollTween.stop();
      }
      stopPanning = true;

      // If the content isn't currently speeding up, ease it to a stop. (If it is speeding up, the speedUpRepeaters will handle easing.)
      if (stopSpeeding) {
        cardsRow = element[0].querySelector('.cards-row');
        accelerateScrollTween = new TWEEN.Tween(cardsRow).to({
          scrollLeft: cardsRow.scrollLeft + d / 4 * direction
        }, t / 4).easing(TWEEN.Easing.Cubic.Out).onStart(function () {}).onComplete(function () {
          stopPanning = true;
          _showHideButtons();
          cancelAnimationFrame(panFrame);
        });
        accelerateScrollTween.start();
        _scrollTweenRepeater();
      }
    } else {
      $timeout.cancel(hoverTimer);
    }
  }

  // Updates Tween.js frames.
  function _scrollTweenRepeater() {
    TWEEN.update();
    requestAnimationFrame(_scrollTweenRepeater);
  }

  // Makes the content scroll to the left. Repeats until `stopPanning` is true.
  function _panLeftRepeater() {
    if (!stopPanning) {
      cardsRow.scrollLeft = cardsRow.scrollLeft + d * v * 1;
      panFrame = requestAnimationFrame(_panLeftRepeater);
    } else {
      cancelAnimationFrame(panFrame);
      stopPanning = true;
    }
  }

  // Makes the content scroll to the right. Repeats until `stopPanning` is true.
  function _panRightRepeater() {
    if (!stopPanning) {
      cardsRow.scrollLeft = cardsRow.scrollLeft + d * v * -1;
      panFrame = requestAnimationFrame(_panRightRepeater);
    } else {
      cancelAnimationFrame(panFrame);
      stopPanning = true;
    }
  }

  // This might seem like a pointless conversion, but I think it's better that words like "left" and "right" are used in the template, and "translated" later.
  function _interpretDirection(directionFromTemplate) {
    switch (directionFromTemplate) {
      case 'left':
        return 1;
      case 'right':
        return -1;
      default:
        $log.error('No scroll direction given.');
        return;
    }
  }

  // Makes the content jump to the left. This is similar to jumpScroll, except that it takes into account the panning velocity (v).
  function _speedUpLeftRepeater() {
    // k = Easing Progress
    var deltaTime = window.performance.now() - startTime;
    var k = deltaTime / t;
    // Speed up phase should happen over a shorter distance than regular jumpScrolling.
    var _d = d / 2;

    if (!stopSpeeding) {
      // Different easing functions for the beginning and ending of the spped up phase.
      // If we end up needing another function in here, let's start a library of alternate easing functions.
      if (k <= 0.5) {
        cardsRow.scrollLeft = cardsRow.scrollLeft + (_d * k * k + d * v);
      } else {
        cardsRow.scrollLeft = cardsRow.scrollLeft + (_d * k * (1 - k) + d * v);
      }
      speedUpFrame = requestAnimationFrame(_speedUpLeftRepeater);
    } else {
      // Go back to regular panning
      cancelAnimationFrame(speedUpFrame);
      _showHideButtons();
      panFrame = requestAnimationFrame(_panLeftRepeater);
      return;
    }
    stopSpeeding = cardsRow.scrollLeft === cardsRow.scrollLeftMax || k >= 1;
  }

  // Makes the content jump to the right. This is similar to jumpScroll, except that it takes into account the panning velocity (v).
  function _speedUpRightRepeater() {
    // k = Easing Progress
    var deltaTime = window.performance.now() - startTime;
    var k = deltaTime / t;
    // Speed up phase should happen over a shorter distance than regular jumpScrolling.
    var _d = d / 2;

    if (!stopSpeeding) {
      // Different easing functions for the beginning and ending of the speed up phase.
      if (k <= 0.5) {
        cardsRow.scrollLeft = cardsRow.scrollLeft + (_d * k * k + d * v) * -1;
      } else {
        cardsRow.scrollLeft = cardsRow.scrollLeft + (_d * k * (1 - k) + d * v) * -1;
      }
      speedUpFrame = requestAnimationFrame(_speedUpRightRepeater);
    } else {
      // Go back to regular panning
      cancelAnimationFrame(speedUpFrame);
      _showHideButtons();
      panFrame = requestAnimationFrame(_panRightRepeater);
      return;
    }
    stopSpeeding = cardsRow.scrollLeft === 0 || k >= 1;
  }

  // If the content is already panning, this this cancel the panning animation and start the speed up animation.
  // It also switches back to the regular panning animation when told to.
  function _speedUp(direction) {
    cancelAnimationFrame(panFrame);
    if (!stopSpeeding) {
      if (direction === 1) {
        speedUpFrame = requestAnimationFrame(_speedUpLeftRepeater);
      } else {
        speedUpFrame = requestAnimationFrame(_speedUpRightRepeater);
      }
    } else {
      // Go back to regular panning
      cancelAnimationFrame(speedUpFrame);
      if (direction === 1) {
        panFrame = requestAnimationFrame(_panLeftRepeater);
      } else {
        panFrame = requestAnimationFrame(_panRightRepeater);
      }
      return;
    }
    stopSpeeding = cardsRow.scrollLeft === cardsRow.scrollLeftMax;
  }
}]);